import { render, staticRenderFns } from "./Email.vue?vue&type=template&id=1d45b17a&scoped=true&"
import script from "./Email.ts?vue&type=script&lang=ts&"
export * from "./Email.ts?vue&type=script&lang=ts&"
import style0 from "./Email.vue?vue&type=style&index=0&id=1d45b17a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d45b17a",
  null
  
)

export default component.exports